module.exports = "/packs/images/products/all-flavors-a1c833e49cfcf4a26ddf4692c5de8c3d.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/all-flavors.png
// module id = 1775
// module chunks = 0